import type { FC, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from 'features/app/hooks';
import { useCallStateResetBoundary } from 'features/call/call-base/hooks';
import { CallPageStatus } from 'features/call/call-ui-state/enums';
import { selectCallPageStatus } from 'features/call/call-ui-state/store';
import { PageRoute } from 'features/router/routes';
import {
  pendingSessionSelector,
  sessionIdSelector,
} from 'features/session/store';

interface RequireRnsSessionProps {
  children: ReactElement;
}

export const RequireRnsSession: FC<RequireRnsSessionProps> = ({ children }) => {
  const sessionId = useAppSelector(sessionIdSelector);
  const pendingSession = useAppSelector(pendingSessionSelector);
  const callPageStatus = useAppSelector(selectCallPageStatus);

  const shouldRedirect =
    !sessionId &&
    !pendingSession &&
    callPageStatus !== CallPageStatus.TEAMING_OFFER_CANCELED;

  useCallStateResetBoundary(shouldRedirect);

  if (!shouldRedirect) {
    return children;
  }

  return <Navigate replace to={PageRoute.MAIN} />;
};
